
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchCandidateDetails } from "../store/candidateDetails.thunk";
import { clearCandidateDetails } from "../store/candidateDetailsSlice";

export default function useCandidateDetails(
  applicationId?: string
) {
  const dispatch = useDispatch<any>();

  const {
    data,
    loading,
    refreshing,
    error,
  } = useSelector(
    (state: any) => state.candidateDetails
  );

  useEffect(() => {
    if (!applicationId) {
      dispatch(clearCandidateDetails());
      return;
    }

    dispatch(fetchCandidateDetails(applicationId));

    return () => {
      dispatch(clearCandidateDetails());
    };
  }, [applicationId, dispatch]);

  const refetch = () => {
    if (!applicationId) return;
    return dispatch(fetchCandidateDetails(applicationId));
  };

  return {
    data,
    loading,
    refreshing,
    error,
    refetch,
  };
}
